// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "Content/" + chunkId + "-" + "9c0c50c26f96c1aa3463" + ".css";
};